import { cn } from "@/utils/cn";

export default function PlayLoadingIcon({ className }: { className?: string; }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('animate-spin animation-duration-2000', className)}
    >
      <g clipPath="url(#clip0_259_8492)">
        <rect width="20" height="20" rx="10" fill="#667085" />
        <g clipPath="url(#clip1_259_8492)">
          <path
            d="M10 5.125V6.375M10 13V15M6.875 10H5.125M14.625 10H13.875M13.2286 13.2286L12.875 12.875M13.3321 6.70789L12.625 7.415M6.46079 13.5392L7.875 12.125M6.56434 6.60434L7.625 7.665"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_259_8492">
          <rect width="20" height="20" fill="white" />
        </clipPath>
        <clipPath id="clip1_259_8492">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export const displayName = "PlayLoadingIcon";
